import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import request from "../../../network/request";
// import Button from "../../../components/Button";
import useGetCh from "../../../hooks/useGetCh";
import { IReserveDetail } from "../../new-order/types";
import { reportUserBehavior } from "../../../utils/report";
import { sendReport } from "../../../utils/reporter";
import "./indexV2.scss";

export default function () {
  const history = useHistory();
  const ch = useGetCh();
  const { orderId } = useParams<any>();
  const query = useMemo(
    () => new URLSearchParams(history.location.search),
    [history.location.search]
  ); 
  // 是否在工作时间
  const withinWorkHour = query.get("withinWorkHour") || "1"; // 默认在工作时间
  // 是否是今日预约
  const today = query.get("today") || "1"; // 默认今日
  const [hasPickupRights, setHasPickupRights] = useState(false);
  const [orderDetail, setOrderDetail] = useState<IReserveDetail | null>(null);

  useEffect(() => {
    document.title = "预约维保";
  }, []);

  useEffect(() => {
    sendReport({
      mcode: "预约结果页访问量",
      type: "page",
      point: "P11188`B001",
    });
  }, []);

  useEffect(() => {
    if (!orderDetail) return;
    const { drivingDto } = orderDetail;
    setHasPickupRights(!!drivingDto);
  }, [orderDetail]);

  const handleLinkToDetail = useCallback(() => {
    history.push(
      `/serviceOrders/orderDetail/reserveDetailV2?reserveOrderCode=${orderDetail?.reserveOrderCode}&ch=${ch}`
    );

    sendReport({
      mcode: "查看预约单按钮点击",
      point: "P11188`B004",
    });
  }, [history, orderDetail, ch]);

  const fetchReserveDetailData = useCallback(async () => {
    try {
      const url = "/serviceOrder/getReserveDetail";
      const data = {
        reserveOrderCode: orderId,
      };
      const res: any = await request(url, data, "post");
      setOrderDetail(res);
      // if (res?.drivingDto?.isDisplayMap) {
      //   setDriverPosition({
      //     lng: res?.drivingDto?.curLng || null,
      //     lat: res?.drivingDto?.curLat || null,
      //     angle: res?.drivingDto?.angle || null,
      //   });
      // }
      // window.scrollTo(0, 0);
      reportUserBehavior({
        so: "J001002",
        mcode: "reserve_detail__req_get_reserve_order_detail_success",
        ch,
        pa: `status=success\`reserveId=${orderId}`,
      });
    } catch (err) {
      reportUserBehavior({
        so: "J001002",
        mcode: "reserve_detail__req_get_reserve_order_detail_error",
        ch,
        pa: `status=error\`reserveId=${orderId}`,
      });
      // setError(true);
      // setErrorMsg((err as any).message || "获取预约订单失败，请稍后重试");
    }
  }, [orderId, ch]);

  useEffect(() => {
    // 查询预约单详情，用于确定是否有使用上门取车服务
    fetchReserveDetailData();
    // setHasPickupRights(true);
  }, [fetchReserveDetailData]);

  return (
    <div className="reserve-success-page">
      <div className="success-icon"></div>
      <div className="title">预约成功</div>
      {/* <div className="desc">
        请保持手机畅通
        <br />
        如有问题服务管家会联系您
      </div> */}
      <div className="notice-tips">
        <div className="content">
          <div className="notice-icon"></div>
          <div>
            {hasPickupRights ? (
              <p>专人上门取车前将会致电, 请保持电话畅通</p>
            ) : null}
            {withinWorkHour === "1" ? (
              <p>到店时，请携带实体钥匙或NFC卡片</p>
            ) : (
              <>
                <p>1. 到店时，请携带实体钥匙或NFC卡片</p>
                <p>2. 由于当前为门店非工作时间，小鹏汽车智能服务技术专家将于{today === '1' ? '今日' : '次日'}上午致电与您确认服务细节，请您留意接听来电</p>
              </>
            )}
          </div>
        </div>
      </div>
      {orderDetail?.reserveUuid && (
        <div className="actions-field">
          <div className="view-detail-btn" onClick={handleLinkToDetail}>
            查看预约单
          </div>
        </div>
      )}
      {/* <Button fixed={true} onClick={handleLinkToDetail}>
        <span>确定</span>
      </Button> */}
    </div>
  );
}
